<template>
  <div class="centered-container">
    <p>You are now logged out.</p>
  </div>
</template>

<script>
import { auth } from '@/middleware/auth';
import router from "@/router";

export default {
  name: "Logout",
  components: {
  },
  data() {
    return {};
  },
  computed: {},
  beforeMount: async () => {
    if (auth.isUserSignedIn()) {
      try {
        await auth.signOut();
      } catch(err) {
        console.log(err);
      }
    }else{
      router.push({name: 'login'});
    }
  },
  methods: {}
};
</script>
<style lang="scss">
@import "@/assets/styles/common/_variables.scss";
</style>



// WEBPACK FOOTER //
// src/views/auth/Logout.vue